var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"NavButton"},on:{"click":_vm.goToForm}},[_c('i',{staticClass:"el-icon-edit-outline"}),_c('p',[_vm._v("立即預約")])])}
var staticRenderFns = []

export { render, staticRenderFns }